<h4 class="dealer-name text-center">
    <span class="truncate">{{dealerDetail?.dealerName}}</span>
</h4>